import {Component} from '@angular/core';
import {MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-demo-end-modal',
    templateUrl: './demo-end-modal.component.html',
    imports: [
        MatIconModule,
        MatDialogModule,
        TranslateModule,
    ],
    styleUrls: ['./demo-end-modal.component.scss']
})
export class DemoEndModalComponent {
    constructor(public dialogRef: MatDialogRef<DemoEndModalComponent>,) {
    }

}